/**
 * @param {string} [name]
 * @returns {string}
 */
export function getAgentInitials(name) {
  if (!name || typeof name !== 'string') return 'AI';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return 'AI';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

/**
 * @param {unknown} starters
 * @returns {string[]}
 */
export function normalizeConversationStarters(starters) {
  if (!Array.isArray(starters)) return [];
  return starters.map((s) => (typeof s === 'string' ? s : s?.text || '')).filter(Boolean);
}
